import { render, staticRenderFns } from "./UnificarFichas.vue?vue&type=template&id=2a52be2c&scoped=true"
import script from "./UnificarFichas.vue?vue&type=script&lang=js"
export * from "./UnificarFichas.vue?vue&type=script&lang=js"
import style0 from "./UnificarFichas.vue?vue&type=style&index=0&id=2a52be2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a52be2c",
  null
  
)

export default component.exports